<template>
  <section v-if="currentModule">
    <nav-base
      title="Contenido del módulo"
      :showBack="true"
      :headerInfo="`Curso: ${currentCourse.course_title}\nMódulo: ${currentModule.module_name}`"
      :onBack="onBack"
    />
    <Loader v-if="cargando" />
    <div class="card" v-else>
      <v-tabs
        v-model="active"
        xs8
        sm8
        md8
        lg8
        xl8
        offset-xs2
        offset-sm2
        offset-md2
        offset-lg2
        offset-xl2
        height="auto"
        fixed-tabs
      >
        <v-tabs-bar class="white" dark>
          <v-tabs-item
            v-for="tab in tabs"
            :key="tab"
            :href="'#' + tab"
            height="auto"
          >
            <p class="mb-0 subheading">
              {{ tab }}
            </p>
          </v-tabs-item>
          <v-tabs-slider
            color="teal darken-1"
            style="height: 10%"
          ></v-tabs-slider>
        </v-tabs-bar>
        <v-tabs-items>
          <v-tabs-content v-for="tab in tabs" :key="tab" :id="tab">
            <v-layout row wrap class="p-px-4 p-py-5">
              <v-flex
                v-if="tab === 'Competencias'"
                xs12
                sm8
                md8
                lg8
                xl8
                offset-sm2
                offset-md2
                offset-lg2
                offset-xl2
              >
                <div v-if="curso.competitions.length != 0">
                  <p class="text-xs-left display-1 accent--text">
                    Lista de competencias
                  </p>
                  <v-list three-line>
                    <template>
                      <v-list-tile
                        v-for="item in curso.competitions"
                        :key="item.id"
                      >
                        <v-list-tile-action>
                          <v-icon color="accent">send</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <p class="p-text-justify">
                            <b>{{ item.competition_title }} </b>
                            {{ item.competition_description }}
                          </p>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </div>
                <div align="center" class="mt-2" v-else>
                  <i
                    style="font-size: 8em; color: #e0e0e0"
                    class="material-icons"
                  >
                    error
                  </i>
                  <p style="color: #757575">
                    No se encontrarón competencias para este módulo
                  </p>
                </div>
              </v-flex>
              <!-- Antecedentes Generales -->
              <v-flex
                v-if="tab === 'Antecedentes Generales'"
                xs12
                sm8
                md8
                lg8
                xl8
                offset-sm2
                offset-md2
                offset-lg2
                offset-xl2
              >
                <p class="accent--text display-1">Antecedentes Generales</p>

                <br />
                <p>
                  <b>Plan Formativo:</b>
                  {{ courseName }}
                </p>
                <br />
                <p>
                  <b>Año:</b>
                  {{ modulo.module_year }}
                </p>
                <br />
                <p class="p-text-justify p-mb-5">
                  <b>Forma de evaluación y aprobación del módulo:</b>
                  {{ curso.courseType }}
                </p>

                <br />
                <div>
                  <div class="row-text-container">
                    <p>
                      <b>Nombre del Módulo:</b>
                      {{ modulo.module_name }}
                    </p>
                    <p v-if="modulo.module_modality">
                      <b>Modalidad: </b>
                      {{ modulo.module_modality }}
                    </p>
                  </div>
                  <br />
                </div>
                <div v-if="modulo.course_start_date || modulo.course_end_date">
                  <div class="row-text-container">
                    <p v-if="modulo.course_start_date">
                      <b>Fecha de inicio:</b>
                      {{ modulo.course_start_date }}
                    </p>
                    <p v-if="modulo.course_end_date">
                      <b>Fecha de término:</b>
                      {{ modulo.course_end_date }}
                    </p>
                  </div>
                  <br />
                </div>
                <p class="p-text-justify p-mb-5">
                  <b>Docente:</b>
                  {{ modulo.autor.nombre + " " + modulo.autor.apellido }}
                </p>
                <br />
                <p>
                  <b>Email:</b>
                  {{ modulo.autor.email }}
                </p>
                <br />
                <p>
                  <b>Fono:</b>
                  {{ validateFono(modulo.autor.fono) }}
                </p>
                <br />
                <p v-if="modulo.module_formation" class="p-text-justify p-mb-5">
                  <b>Área de Formación:</b>
                  {{ modulo.module_formation }}
                </p>
                <p
                  v-if="modulo.module_competence"
                  class="p-text-justify p-mb-5"
                >
                  <b>Competencia Módulo:</b>
                  {{ modulo.module_competence }}
                </p>
                <p
                  v-if="modulo.module_description"
                  class="p-text-justify p-mb-5"
                >
                  <b>Descripción del Módulo:</b>
                  {{ modulo.module_description }}
                </p>
              </v-flex>
              <!-- Resultados de Apredizaje -->
              <v-flex
                v-if="tab === 'Resultados de Apredizaje'"
                xs12
                sm8
                md8
                lg8
                xl8
                offset-sm2
                offset-md2
                offset-lg2
                offset-xl2
              >
                <div v-if="curso.objectives.length > 0">
                  <p class="accent--text display-1">
                    Resultados de aprendizaje
                  </p>
                  <v-list three-line subheader ripple>
                    <v-list-tile
                      v-for="item in curso.objectives"
                      class="lighten-4"
                      v-bind:key="item.id"
                      avatar
                    >
                      <v-list-tile-avatar>
                        <v-icon class="accent white--text">check_circle</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <p class="p-text-justify">
                          {{ item.objetive_description }}
                        </p>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <br />
                </div>
                <div align="center" class="mt-2" v-else>
                  <i
                    style="font-size: 8em; color: #e0e0e0"
                    class="material-icons"
                  >
                    error
                  </i>
                  <p style="color: #757575">
                    No se encontrarón resultados de aprendizaje para este módulo
                  </p>
                </div>
              </v-flex>
              <!-- Unidades de Aprendizaje -->
              <v-flex
                v-if="tab === 'Unidades de Aprendizaje'"
                xs12
                sm8
                md8
                lg8
                xl8
                offset-sm2
                offset-md2
                offset-lg2
                offset-xl2
              >
                <p class="accent--text display-1">Unidades de Aprendizaje</p>

                <DataTable
                  :value="unidadesAprendizaje"
                  :resizableColumns="true"
                  columnResizeMode="fit"
                  showGridlines
                  responsiveLayout="scroll"
                >
                  <Column
                    field="aprendizajeEsperado"
                    header="Aprendizaje Esperado"
                  />
                  <Column
                    field="criterioEvaluacion"
                    header="Criterio de Evaluacion"
                  />
                  <Column
                    field="estrategiaens"
                    header="Estrategia de enseñanzas"
                  />
                  <Column
                    field="estrategiaeva"
                    header="Estrategia de Evaluacion"
                  />
                </DataTable>

                <br />
              </v-flex>
              <!-- Bibliografia -->
              <v-flex
                v-if="tab === 'Bibliografía'"
                xs12
                sm8
                md8
                lg8
                xl8
                offset-sm2
                offset-md2
                offset-lg2
                offset-xl2
              >
                <div v-if="curso.bibliographies.length > 0">
                  <p class="accent--text display-1">Bibliografía</p>
                  <v-list three-line subheader ripple>
                    <v-list-tile
                      v-for="item in curso.bibliographies"
                      class="lighten-4"
                      v-bind:key="item.id"
                      avatar
                    >
                      <v-list-tile-avatar>
                        <v-icon class="accent white--text">auto_stories</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <p class="p-text-justify">
                          {{ item.bibliography_description }}
                        </p>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <br />
                </div>
                <div align="center" class="mt-2" v-else>
                  <i
                    style="font-size: 8em; color: #e0e0e0"
                    class="material-icons"
                  >
                    error
                  </i>
                  <p style="color: #757575">
                    No se encontró bibliografía para este módulo
                  </p>
                </div>
              </v-flex>
              <!-- Contenido del Curso -->
              <v-flex
                v-if="tab === 'Actividades'"
                xs12
                sm8
                md8
                lg8
                xl8
                offset-sm2
                offset-md2
                offset-lg2
                offset-xl2
              >
                <ProgressBar :value="progress">
                  Lecciones completadas: {{ progress }}%
                </ProgressBar>
                <div v-if="curso.units.length != 0">
                  <template>
                    <div>
                      <v-breadcrumbs large justify-end>
                        <v-icon slot="divider" x-large style="min-height: 30px"
                          >forward</v-icon
                        >
                        <v-breadcrumbs-item
                          v-for="item in items"
                          :key="item.text"
                          :disabled="item.disabled"
                        >
                          {{ item.text }}
                        </v-breadcrumbs-item>
                      </v-breadcrumbs>
                    </div>
                  </template>
                  <v-layout row class="mx-0">
                    <v-expansion-panel expand>
                      <v-expansion-panel-content
                        v-for="unidad in curso.units"
                        :key="unidad.id"
                        class="icono white--text header__icon"
                        style="background-color: #f4f4f4"
                      >
                        <div slot="header">
                          <p
                            class="subheading accent--text"
                            style="margin-bottom: 0"
                          >
                            {{ unidad.unity_name }}
                          </p>
                        </div>
                        <v-card>
                          <v-layout row>
                            <v-flex xs12 sm12>
                              <v-list>
                                <v-list-tile
                                  v-for="lesson in unidad.lessons"
                                  class="lesson-list-item"
                                  :key="lesson.id"
                                  @click="verLeccion(lesson)"
                                >
                                  <v-icon class="mr-4" color="teal darken-1"
                                    >play_circle_outline</v-icon
                                  >
                                  <v-list-tile-content class="p-pr-2">
                                    {{ lesson.lesson_title }}
                                  </v-list-tile-content>
                                  <div>
                                    <span
                                      class="
                                        p-text-bold p-d-none p-d-xl-inline-block
                                      "
                                    >
                                      {{
                                        lesson.lesson_start_date
                                          ? new Date(
                                              lesson.lesson_start_date
                                            ).toLocaleDateString()
                                          : ""
                                      }}
                                    </span>
                                    <v-icon
                                      v-if="
                                        lesson.status &&
                                        completed_lessons.includes(lesson.id)
                                      "
                                      class="mx-4"
                                      color="green"
                                    >
                                      check
                                    </v-icon>
                                    <span
                                      v-else
                                      class="caption p-orange pl-3 pr-3"
                                    >
                                      INGRESAR
                                    </span>
                                  </div>
                                </v-list-tile>
                              </v-list>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-layout>
                </div>
                <div align="center" class="mt-4" v-else>
                  <i
                    style="font-size: 8em; color: #e0e0e0"
                    class="material-icons"
                  >
                    error
                  </i>
                  <p style="color: #757575">
                    No se encontrarón unidades para este módulo
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-tabs-content>
        </v-tabs-items>
      </v-tabs>
    </div>
  </section>
</template>

<script>
import Role from "@/utils/role";
import { mapState, mapMutations } from "vuex";
import moduleService from "@/services/axios/module.service";
import { enrollUsersInProgressService } from "@/services/EnrollUsersInProgress.service";
import * as moment from "moment";
export default {
  data() {
    return {
      progress: 0,
      modulo: {},
      completed_lessons: [],
      courseName: "",
      cargando: true,
      idCurso: 0,
      request: {},
      unidades: [],
      objetivos: [],
      inscrito: true,
      tabs: [
        "Antecedentes Generales",
        "Actividades",
        "Resultados de Apredizaje",
        "Competencias",
        "Bibliografía",
      ],
      active: null,
      items: [
        {
          text: "Unidad",
          disabled: false,
        },
        {
          text: "Lecciones",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      role: (state) => state.role,
      currentModule: (state) => state.navigation.currentModule,
      currentCourse: (state) => state.navigation.currentCourse,
    }),
    isAStudent() {
      return this.role === Role.STUDENT;
    },
  },
  mounted() {
    this.idModule = this.currentModule;
    this.courseName = this.currentCourse.course_title;
    this.userId = this.user.id;
    this.loadModule();
    this.getUserCourseProgress();
  },
  methods: {
    ...mapMutations("navigation", ["setCurrentModule", "setCurrentLesson"]),
    getUserCourseProgress() {
      moduleService
        .getUserCourseProgress(this.idModule.module_id, this.userId)
        .then(({ data }) => {
          this.progress = data.progress;
          this.completed_lessons = data.completed_lessons.map(
            (e) => e.lesson_id
          );
        });
    },
    loadModule() {
      let vm = this;
      moduleService.getById(this.idModule.module_id).then(({ data }) => {
        vm.modulo = data;
        vm.curso = data;
        vm.cargando = false;
      });
    },
    formatDate(value) {
      if (value === null) {
        return "Sin especificar";
      }
      return moment(value.meeting_start_date).format("L  ");
    },
    validateFono(value) {
      if (value === null || value === "0") {
        return "Sin especificar";
      }
      return value;
    },
    verLeccion(lesson) {
      const name = this.isAStudent ? "LessonDetail" : "TeacherLessonDetail";
      this.setCurrentLesson(lesson);
      this.$router.push({ name });
    },
    enrollUsersInProgress(id) {
      let vm = this;
      vm.request.id_curso = id;
      enrollUsersInProgressService.save(vm.request).then(
        (data) => {
          vm.inscrito = data.body;
        },
        (response) => {
          vm.loadingCurso = false;
        }
      );
    },
    linkTo(link) {
      window.open(`${link}`, "_blank");
    },
    next() {
      const i = (this.tabs.indexOf(this.active) + 1) % this.tabs.length;
      this.active = this.tabs[i];
    },
    onBack() {
      this.setCurrentModule(null);
    },
  },
};
</script>

<style scoped>
#letra-naranja {
  color: #eb6330;
}

.color-naranja {
  color: #eb6330;
}

.btn-large {
  width: 20%;
}

#back-naranja {
  background-color: #eb6330;
}

#back-grey {
  background-color: #747474;
}

.text-bold {
  font-weight: bold;
}

.p-orange {
  background-color: #eb6330;
  color: white;
}

.float_trans {
  background: #ffffff80;
  opacity: 1 !important;
  filter: alpha(opacity=30); /*For IE8 and earlier*/
}

.gris {
  background-color: #eeeeee;
}
.material-icons.icon {
  color: red;
}
.row-text-container {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Curso/ShowCurso.vue